/* eslint-disable */
// @ts-nocheck
import { PixelCrop } from 'react-image-crop';

export async function canvasPreview(image: HTMLImageElement, canvas: HTMLCanvasElement, crop: PixelCrop) {
  const ctx = canvas.getContext('2d');

  const cropImg = document.getElementById('crop-img');

  const scaleX = image.width / cropImg.width;
  const scaleY = image.height / cropImg.height;

  if (!ctx) {
    throw new Error('No 2d context');
  }

  canvas.width = crop.width * scaleX;
  canvas.height = crop.height * scaleY;

  ctx.save();

  ctx?.drawImage(
    image,
    scaleX * crop.x,
    scaleY * crop.y,
    scaleX * crop.width,
    scaleY * crop.height,
    0,
    0,
    scaleX * crop.width,
    scaleY * crop.height
  );
  ctx.restore();
}
